import {Command} from './commands/Command';
import {Injectable} from '@angular/core';
import {actionToCommandMappings} from './ActionToCommandMap';
import {CommandFactory} from './CommandFactory';

@Injectable()
export class EventLogService {

  private history: Array<Command<any>> = [];
  private historyLimit = 20;

  constructor(
    private commandFactory: CommandFactory
  ) {
  }

  private addToHistory(command: Command<any>) {
    if (this.history.length === this.historyLimit) {
      const removedCommand = this.history.shift();
      removedCommand.dispose();
    }
    this.history.push(command);
  }

  dispatch(action) {
    const actionToCommandMap = actionToCommandMappings.find(mapping => action.constructor === mapping.action);
    if (actionToCommandMap) {
      const command = this.commandFactory.create(actionToCommandMap.command);
      this.addToHistory(command);
      command.do(action);
    } else {
      console.error(`cant find related command for ${action} action`);
    }
  }

  revert() {
    const command = this.history.pop();
    if (command) {
      command.undo();
      command.dispose();
    }
  }

}





// WEBPACK FOOTER //
// ./src/app/services/eventLog/eventLog.service.ts